const methylation_summary = {
    "P18": [
        {
            "Samples": "CA12DAP_1",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "9.5",
            "C(Mb)": "3003.9",
            "CG(Mb)": "293.2",
            "CHG(Mb)": "440.6",
            "CHH(Mb)": "2270.1",
            "meanC(%)": "10.98",
            "MeanCG(%)": "55.73",
            "MeanCHG(%)": "26.11",
            "MeanCHH(%)": "2.26"
        },
        {
            "Samples": "CA12DAP_2",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "9.3",
            "C(Mb)": "2949.4",
            "CG(Mb)": "290.4",
            "CHG(Mb)": "428.3",
            "CHH(Mb)": "2230.7",
            "meanC(%)": "10.57",
            "MeanCG(%)": "52.48",
            "MeanCHG(%)": "25.33",
            "MeanCHH(%)": "2.28"
        },
        {
            "Samples": "CA12DAP_3",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "9.2",
            "C(Mb)": "2911.3",
            "CG(Mb)": "283.6",
            "CHG(Mb)": "422.1",
            "CHH(Mb)": "2205.6",
            "meanC(%)": "10.72",
            "MeanCG(%)": "53.87",
            "MeanCHG(%)": "25.41",
            "MeanCHH(%)": "2.36"
        },
        {
            "Samples": "CA15DAP_1",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "12.8",
            "C(Mb)": "4065.5",
            "CG(Mb)": "406",
            "CHG(Mb)": "587.3",
            "CHH(Mb)": "3072.3",
            "meanC(%)": "10.85",
            "MeanCG(%)": "51.42",
            "MeanCHG(%)": "25.05",
            "MeanCHH(%)": "2.78"
        },
        {
            "Samples": "CA15DAP_2",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "13.1",
            "C(Mb)": "4173.5",
            "CG(Mb)": "405.9",
            "CHG(Mb)": "599.5",
            "CHH(Mb)": "3168.2",
            "meanC(%)": "10.62",
            "MeanCG(%)": "51.27",
            "MeanCHG(%)": "24.61",
            "MeanCHH(%)": "2.77"
        },
        {
            "Samples": "CA15DAP_3",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "9.1",
            "C(Mb)": "2895.2",
            "CG(Mb)": "283.2",
            "CHG(Mb)": "418",
            "CHH(Mb)": "2194",
            "meanC(%)": "10.8",
            "MeanCG(%)": "52.03",
            "MeanCHG(%)": "25.08",
            "MeanCHH(%)": "2.76"
        },
        {
            "Samples": "CA9DAP_1",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "9.9",
            "C(Mb)": "3144",
            "CG(Mb)": "300.8",
            "CHG(Mb)": "466.6",
            "CHH(Mb)": "2376.6",
            "meanC(%)": "11.61",
            "MeanCG(%)": "61.51",
            "MeanCHG(%)": "29.01",
            "MeanCHH(%)": "1.88"
        },
        {
            "Samples": "CA9DAP_2",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "10.5",
            "C(Mb)": "3327.8",
            "CG(Mb)": "310.9",
            "CHG(Mb)": "492.5",
            "CHH(Mb)": "2524.4",
            "meanC(%)": "10.82",
            "MeanCG(%)": "60.23",
            "MeanCHG(%)": "26.19",
            "MeanCHH(%)": "1.74"
        },
        {
            "Samples": "CA9DAP_3",
            "Varietys": "Ancient_Chinese_Lotus",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "11.1",
            "C(Mb)": "3525.9",
            "CG(Mb)": "330.4",
            "CHG(Mb)": "517.1",
            "CHH(Mb)": "2678.4",
            "meanC(%)": "10.87",
            "MeanCG(%)": "59.27",
            "MeanCHG(%)": "26.35",
            "MeanCHH(%)": "1.91"
        },
        {
            "Samples": "ZY12DAP_1",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "9.2",
            "C(Mb)": "2916.5",
            "CG(Mb)": "287.5",
            "CHG(Mb)": "413.1",
            "CHH(Mb)": "2215.9",
            "meanC(%)": "9.83",
            "MeanCG(%)": "42.94",
            "MeanCHG(%)": "23.62",
            "MeanCHH(%)": "2.97"
        },
        {
            "Samples": "ZY12DAP_2",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "8.6",
            "C(Mb)": "2733.5",
            "CG(Mb)": "262.7",
            "CHG(Mb)": "387.7",
            "CHH(Mb)": "2083.1",
            "meanC(%)": "10.03",
            "MeanCG(%)": "44.78",
            "MeanCHG(%)": "23.8",
            "MeanCHH(%)": "3.08"
        },
        {
            "Samples": "ZY12DAP_3",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "12_days_after_pollination",
            "C_covgMean": "6.1",
            "C(Mb)": "1925.1",
            "CG(Mb)": "183.4",
            "CHG(Mb)": "277.6",
            "CHH(Mb)": "1464.1",
            "meanC(%)": "10.61",
            "MeanCG(%)": "52.54",
            "MeanCHG(%)": "24.55",
            "MeanCHH(%)": "2.71"
        },
        {
            "Samples": "ZY15DAP_1",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "8.1",
            "C(Mb)": "2587.9",
            "CG(Mb)": "260.4",
            "CHG(Mb)": "376.4",
            "CHH(Mb)": "1951.1",
            "meanC(%)": "10.08",
            "MeanCG(%)": "43.47",
            "MeanCHG(%)": "23.1",
            "MeanCHH(%)": "3.11"
        },
        {
            "Samples": "ZY15DAP_2",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "4.9",
            "C(Mb)": "1552.9",
            "CG(Mb)": "147.9",
            "CHG(Mb)": "218.5",
            "CHH(Mb)": "1186.5",
            "meanC(%)": "9.79",
            "MeanCG(%)": "43.85",
            "MeanCHG(%)": "22.88",
            "MeanCHH(%)": "3.14"
        },
        {
            "Samples": "ZY15DAP_3",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "15_days_after_pollination",
            "C_covgMean": "4.9",
            "C(Mb)": "1560.9",
            "CG(Mb)": "148.8",
            "CHG(Mb)": "219.5",
            "CHH(Mb)": "1192.7",
            "meanC(%)": "10.27",
            "MeanCG(%)": "43.94",
            "MeanCHG(%)": "23.56",
            "MeanCHH(%)": "3.63"
        },
        {
            "Samples": "ZY9DAP_1",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "8.4",
            "C(Mb)": "2678.5",
            "CG(Mb)": "247.1",
            "CHG(Mb)": "388.1",
            "CHH(Mb)": "2043.4",
            "meanC(%)": "10.25",
            "MeanCG(%)": "52.81",
            "MeanCHG(%)": "25.71",
            "MeanCHH(%)": "2.17"
        },
        {
            "Samples": "ZY9DAP_2",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "9.4",
            "C(Mb)": "2994.1",
            "CG(Mb)": "288.2",
            "CHG(Mb)": "440.8",
            "CHH(Mb)": "2265",
            "meanC(%)": "10.57",
            "MeanCG(%)": "51.37",
            "MeanCHG(%)": "25.54",
            "MeanCHH(%)": "2.47"
        },
        {
            "Samples": "ZY9DAP_3",
            "Varietys": "Plant_Research_No.1",
            "Tissues": "Cotyledon",
            "Time": "9_days_after_pollination",
            "C_covgMean": "9.2",
            "C(Mb)": "2911",
            "CG(Mb)": "266.7",
            "CHG(Mb)": "417.4",
            "CHH(Mb)": "2226.9",
            "meanC(%)": "10.1",
            "MeanCG(%)": "51.02",
            "MeanCHG(%)": "24.7",
            "MeanCHH(%)": "2.46"
        }
    ],
    "D4": [
        {
            "Samples": "SRR7073113",
            "Varietys": "Ancient_Lotus",
            "Tissues": "Stamens",
            "Time": "-",
            "C_covgMean": "10.9",
            "C(Mb)": "3454.4",
            "CG(Mb)": "291.1",
            "CHG(Mb)": "498.5",
            "CHH(Mb)": "2664.7",
            "meanC(%)": "10.66",
            "MeanCG(%)": "62.34",
            "MeanCHG(%)": "30.03",
            "MeanCHH(%)": "1.39"
        },
        {
            "Samples": "SRR7073114",
            "Varietys": "Ancient_Lotus",
            "Tissues": "StamenPetals",
            "Time": "-",
            "C_covgMean": "11.2",
            "C(Mb)": "3560.2",
            "CG(Mb)": "303.4",
            "CHG(Mb)": "518.9",
            "CHH(Mb)": "2737.9",
            "meanC(%)": "10.06",
            "MeanCG(%)": "59.9",
            "MeanCHG(%)": "28.77",
            "MeanCHH(%)": "1"
        },
        {
            "Samples": "SRR7073115",
            "Varietys": "Ancient_Lotus",
            "Tissues": "Petals",
            "Time": "-",
            "C_covgMean": "11.5",
            "C(Mb)": "3658.1",
            "CG(Mb)": "321.1",
            "CHG(Mb)": "549",
            "CHH(Mb)": "2788",
            "meanC(%)": "10.25",
            "MeanCG(%)": "60.44",
            "MeanCHG(%)": "28.31",
            "MeanCHH(%)": "0.91"
        },
        {
            "Samples": "SRR7544256",
            "Varietys": "Ancient_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "7.5",
            "C(Mb)": "2372.9",
            "CG(Mb)": "207.3",
            "CHG(Mb)": "338.9",
            "CHH(Mb)": "1826.8",
            "meanC(%)": "11.12",
            "MeanCG(%)": "63.71",
            "MeanCHG(%)": "29.99",
            "MeanCHH(%)": "1.65"
        }
    ],
    "D7": [
        {
            "Samples": "SRR9639507",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "3.5",
            "C(Mb)": "1124.1",
            "CG(Mb)": "106.1",
            "CHG(Mb)": "159.4",
            "CHH(Mb)": "858.6",
            "meanC(%)": "12.81",
            "MeanCG(%)": "64.73",
            "MeanCHG(%)": "33.44",
            "MeanCHH(%)": "2.56"
        },
        {
            "Samples": "SRR9639508",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "8.6",
            "C(Mb)": "2746.6",
            "CG(Mb)": "233.3",
            "CHG(Mb)": "371.7",
            "CHH(Mb)": "2141.6",
            "meanC(%)": "9.68",
            "MeanCG(%)": "59.49",
            "MeanCHG(%)": "27",
            "MeanCHH(%)": "1.25"
        },
        {
            "Samples": "SRR9639509",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "1",
            "C(Mb)": "309.4",
            "CG(Mb)": "26.3",
            "CHG(Mb)": "46",
            "CHH(Mb)": "237.1",
            "meanC(%)": "6.2",
            "MeanCG(%)": "28.76",
            "MeanCHG(%)": "14.5",
            "MeanCHH(%)": "2.08"
        },
        {
            "Samples": "SRR9639510",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "2.5",
            "C(Mb)": "779.3",
            "CG(Mb)": "55.3",
            "CHG(Mb)": "107.3",
            "CHH(Mb)": "616.7",
            "meanC(%)": "6.4",
            "MeanCG(%)": "38.05",
            "MeanCHG(%)": "17.67",
            "MeanCHH(%)": "1.6"
        },
        {
            "Samples": "SRR9639512",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "8",
            "C(Mb)": "2540.6",
            "CG(Mb)": "206",
            "CHG(Mb)": "342.6",
            "CHH(Mb)": "1991.9",
            "meanC(%)": "10.86",
            "MeanCG(%)": "63.42",
            "MeanCHG(%)": "30.46",
            "MeanCHH(%)": "2.05"
        },
        {
            "Samples": "SRR9639513",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "6.2",
            "C(Mb)": "1979.2",
            "CG(Mb)": "155.6",
            "CHG(Mb)": "260.7",
            "CHH(Mb)": "1562.8",
            "meanC(%)": "11.08",
            "MeanCG(%)": "64.91",
            "MeanCHG(%)": "30.45",
            "MeanCHH(%)": "2.49"
        },
        {
            "Samples": "SRR9639516",
            "Varietys": "Wild_Lotus",
            "Tissues": "Seeds",
            "Time": "-",
            "C_covgMean": "3.4",
            "C(Mb)": "1079",
            "CG(Mb)": "87.7",
            "CHG(Mb)": "140.5",
            "CHH(Mb)": "850.8",
            "meanC(%)": "9.44",
            "MeanCG(%)": "59.93",
            "MeanCHG(%)": "26.8",
            "MeanCHH(%)": "1.37"
        }
    ]
}
const ColumsArr=[]
Object.keys(methylation_summary.P18[0]).map(v=>{
    ColumsArr.push({
        key:v,
        title:v,
        dataIndex:v,
        align:'center'
    })
})
const ButtonArr=[]
Object.keys(methylation_summary).map(key=>{
    ButtonArr.push(key)
})
export  {methylation_summary,ColumsArr,ButtonArr}